/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_Keep_Open_WarningInputs */

const en_video_export_keep_open_warning = /** @type {(inputs: Video_Export_Keep_Open_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please leave this window open until your export completes`)
};

const fr_video_export_keep_open_warning = /** @type {(inputs: Video_Export_Keep_Open_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veuillez laisser cette fenetre ouverte jusqu'a la fin de l'exportation`)
};

const de_video_export_keep_open_warning = /** @type {(inputs: Video_Export_Keep_Open_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte lassen Sie dieses Fenster so lange geöffnet, bis Ihr Export abgeschlossen ist.`)
};

const it_video_export_keep_open_warning = /** @type {(inputs: Video_Export_Keep_Open_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Si prega di lasciare aperta questa finestra fino al completamento dell'esportazione`)
};

const ru_video_export_keep_open_warning = /** @type {(inputs: Video_Export_Keep_Open_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пожалуйста, оставьте это окно открытым до завершения экспорта.`)
};

const es_video_export_keep_open_warning = /** @type {(inputs: Video_Export_Keep_Open_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deje esta ventana abierta hasta que se complete la exportación.`)
};

const zh_cn2_video_export_keep_open_warning = /** @type {(inputs: Video_Export_Keep_Open_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请保持此窗口打开，直到导出完成。`)
};

const ja_video_export_keep_open_warning = /** @type {(inputs: Video_Export_Keep_Open_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`エクスポートが完了するまでこのウィンドウを開いたままにしてください`)
};

const hi_video_export_keep_open_warning = /** @type {(inputs: Video_Export_Keep_Open_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कृपया निर्यात पूरा होने तक इस विंडो को खुला रखें।`)
};

const pt_pt2_video_export_keep_open_warning = /** @type {(inputs: Video_Export_Keep_Open_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por favor, deixe esta janela aberta até que a exportação seja concluída.`)
};

/**
* | output |
* | --- |
* | "Please leave this window open until your export completes" |
*
* @param {Video_Export_Keep_Open_WarningInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_keep_open_warning = /** @type {((inputs?: Video_Export_Keep_Open_WarningInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Keep_Open_WarningInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_video_export_keep_open_warning(inputs)
	if (locale === "de") return de_video_export_keep_open_warning(inputs)
	if (locale === "it") return it_video_export_keep_open_warning(inputs)
	if (locale === "ru") return ru_video_export_keep_open_warning(inputs)
	if (locale === "es") return es_video_export_keep_open_warning(inputs)
	if (locale === "zh-CN") return zh_cn2_video_export_keep_open_warning(inputs)
	if (locale === "ja") return ja_video_export_keep_open_warning(inputs)
	if (locale === "hi") return hi_video_export_keep_open_warning(inputs)
	if (locale === "pt-PT") return pt_pt2_video_export_keep_open_warning(inputs)
	return en_video_export_keep_open_warning(inputs)
});